// sets
export const SET_FETCHING_STATES = 'SET_FETCHING_STATES';
export const SET_STATES_LIST = 'SET_STATES_LIST';
export const SET_STATES_LIST_ERROR = 'SET_STATES_LIST_ERROR';

export const SET_FETCHING_COVERAGE_TYPES = 'SET_FETCHING_COVERAGE_TYPES';
export const SET_COVERAGE_TYPES_LIST = 'SET_COVERAGE_TYPES_LIST';
export const SET_COVERAGE_TYPES_LIST_ERROR = 'SET_COVERAGE_TYPES_LIST_ERROR';

export const SET_FETCHING_SEARCH_INSUREDS = 'SET_FETCHING_SEARCH_INSUREDS';
export const SET_SEARCH_INSUREDS_LIST = 'SET_SEARCH_INSUREDS_LIST';
export const SET_SEARCH_INSUREDS_LIST_ERROR = 'SET_SEARCH_INSUREDS_LIST_ERROR';

export const SET_FETCHING_SEARCH_PROJECTS = 'SET_FETCHING_SEARCH_PROJECTS';
export const SET_SEARCH_PROJECTS_LIST = 'SET_SEARCH_PROJECTS_LIST';
export const SET_SEARCH_PROJECTS_LIST_ERROR = 'SET_SEARCH_PROJECTS_LIST_ERROR';

export const SET_FETCHING_SEARCH_HOLDERS = 'SET_FETCHING_SEARCH_HOLDERS';
export const SET_SEARCH_HOLDERS_LIST = 'SET_SEARCH_HOLDERS_LIST';
export const SET_SEARCH_HOLDERS_LIST_ERROR = 'SET_SEARCH_HOLDERS_LIST_ERROR';

export const SET_FETCHING_SEARCH_CONTACTS = 'SET_FETCHING_SEARCH_CONTACTS';
export const SET_SEARCH_CONTACTS_LIST = 'SET_SEARCH_CONTACTS_LIST';
export const SET_SEARCH_CONTACTS_LIST_ERROR = 'SET_SEARCH_CONTACTS_LIST_ERROR';

export const SET_FETCHING_SEARCH_AGENCIES = 'SET_FETCHING_SEARCH_AGENCIES';
export const SET_SEARCH_AGENCIES_LIST = 'SET_SEARCH_AGENCIES_LIST';
export const SET_SEARCH_AGENCIES_LIST_ERROR = 'SET_SEARCH_AGENCIES_LIST_ERROR';